import HttpRequest from '@/libs/axios'
// const baseUrl = 'https://xxbpcapi.jsytest.top/v1/'  //测试
const baseUrl = 'https://api.jzyxxb.cn/v1/' //正式
const axios = new HttpRequest(baseUrl)
export default axios
